"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "initBaseBehavior", {
    enumerable: true,
    get: function() {
        return initBaseBehavior;
    }
});
const _common = require("@nestjs/common");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _CustomKnex = /*#__PURE__*/ _interop_require_default(require("~/db/CustomKnex"));
const _SqlClientFactory = require("~/db/sql-client/lib/SqlClientFactory");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('initBaseBehavior');
async function isSchemaCreateAllowed(tempConnection, dataConfig, skipDatabaseCreation = false) {
    try {
        // check if database user have permission to create new schema
        return await tempConnection.raw("SELECT has_database_privilege(:user, :database, 'CREATE') as has_database_privilege", {
            database: dataConfig.connection.database,
            user: dataConfig.connection.user
        });
    } catch (e) {
        // check if error is due to database not found
        if (e.message.includes('does not exist') && !skipDatabaseCreation) {
            var _dataConfig_searchPath;
            // create sqlClient from dataConfig
            const sqlClient = _SqlClientFactory.SqlClientFactory.create(_extends({}, dataConfig, {
                knex: tempConnection
            }));
            // create database if it doesn't exist
            await sqlClient.createDatabaseIfNotExists({
                database: dataConfig.connection.database,
                schema: ((_dataConfig_searchPath = dataConfig.searchPath) == null ? void 0 : _dataConfig_searchPath[0]) || 'public'
            });
            return isSchemaCreateAllowed(tempConnection, dataConfig, true);
        }
        throw e;
    }
}
async function initBaseBehavior() {
    const dataConfig = await _NcConnectionMgrv2.default.getDataConfig();
    // return if client is not postgres
    if (dataConfig.client !== 'pg') {
        return;
    }
    // disable minimal databases feature if NC_DISABLE_PG_DATA_REFLECTION is set to true
    if (process.env.NC_DISABLE_PG_DATA_REFLECTION === 'true') {
        return;
    }
    let tempConnection;
    try {
        var _schemaCreateAllowed_rows_, _schemaCreateAllowed_rows;
        tempConnection = (0, _CustomKnex.default)(dataConfig);
        const schemaCreateAllowed = await isSchemaCreateAllowed(tempConnection, dataConfig);
        // if schema creation is not allowed, return
        if (!(schemaCreateAllowed == null ? void 0 : (_schemaCreateAllowed_rows = schemaCreateAllowed.rows) == null ? void 0 : (_schemaCreateAllowed_rows_ = _schemaCreateAllowed_rows[0]) == null ? void 0 : _schemaCreateAllowed_rows_.has_database_privilege)) {
            var _dataConfig_connection;
            // set NC_DISABLE_PG_DATA_REFLECTION to true and log warning
            process.env.NC_DISABLE_PG_DATA_REFLECTION = 'true';
            logger.warn(`User ${(_dataConfig_connection = dataConfig.connection) == null ? void 0 : _dataConfig_connection.user} does not have permission to create schema, minimal databases feature will be disabled`);
            return;
        }
        // set NC_DISABLE_PG_DATA_REFLECTION to false
        process.env.NC_DISABLE_PG_DATA_REFLECTION = 'false';
    } catch (error) {
        logger.warn(`Error while checking schema creation permission: ${error.message}`);
        process.env.NC_DISABLE_PG_DATA_REFLECTION = 'true';
    } finally{
        // close the connection since it's only used to verify permission
        await (tempConnection == null ? void 0 : tempConnection.destroy());
    }
}
